import axios from 'axios'
import { Notification, MessageBox, Message, Loading } from 'element-ui'
let loadingInstance = '';
// create an axios instance
const service = axios.create({
  // baseURL: 'http://8.140.199.148:80/hr',
  baseURL: `${window.location.origin}/hr`,
  timeout: 50000,
})

// request interceptor
service.interceptors.request.use(
  config => {
    // loadingInstance = Loading.service({
    //   text: '拼命加载中',
    //   background: 'rgba(0,0,0,0.5)',
    //   spinner: 'el-icon-loading'
    // });
    // const token = localStorage.getItem("token") || ''
    // if (!token) { 
    //   window.location.href = "http://36.134.92.50:86"
    // }
    // const id = this.$route.query.token
    // console.log(id)
    // console.log(token)
    config.headers['Authorization'] = ""
    return config
  },
  error => {
    if (process.env.NODE_ENV === 'development') {
      console.log('过期', error)
    }
    // window.location.href = "http://36.134.92.50:86"
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    // loadingInstance.close();
    const res = response.data
    if (res.code !== 200) {
      Message({
        message: res.msg || '请求出错，请重试',
        type: 'error',
        duration: 1500
      })
      return
      // return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return response
    }
  },
  error => {
    if (process.env.NODE_ENV === 'development') {
      console.log(error) // for debug
    }
    Message({
      message: '请求出错，请重试',
      type: 'error',
      duration: 1500
    })
    // window.location.href = "http://36.134.92.50:86"
    return
    // return Promise.reject(error)
  }
)

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js